export default __webpack_public_path__ + "static/media/poor_inactive.93ce67ce.svg";